import React from "react";
import { formatV3TaxPurchaseSubline } from "../utils/v3taxPlanLabel.js";
import { V3TAX_PURCHASE_LOGO_PATH } from "../constants/v3taxBranding.js";

/** V3Tax-Kauf-Zeile mit Logo — gleicher Look wie RawTransfersTable. */
export default function V3TaxPurchaseTypeLabel({
  tx,
  language = "de",
  leading = null,
  titleClassName = "text-gray-800 font-normal",
  subtitleClassName = "text-[11px] font-medium text-gray-700/90",
}) {
  const subline = formatV3TaxPurchaseSubline(tx, language);

  return (
    <div className={`flex items-start gap-2 min-w-0 ${titleClassName}`}>
      {leading != null ? (
        <span className="mt-0.5 shrink-0" aria-hidden>
          {leading}
        </span>
      ) : null}
      <img
        src={V3TAX_PURCHASE_LOGO_PATH}
        alt="V3Tax"
        className="h-5 w-5 object-cover flex-shrink-0 mt-0.5 rounded-[22%] ring-1 ring-slate-200/70"
        draggable={false}
        onError={(e) => {
          e.currentTarget.style.display = "none";
        }}
      />
      <div className="min-w-0 leading-tight">
        <div className="whitespace-normal break-words">V3Tax</div>
        <div className={`whitespace-normal break-words ${subtitleClassName}`}>{subline}</div>
      </div>
    </div>
  );
}
